<template>
    <div
        class="display-5 px-0 fw-semibold"
        @dblclick="toggleGroup"
    >
        <span
            @click="toggleGroup"
            class="ag-link"
            ><IconComp
                :icon="!isCollpased ? 'fa-caret-right' : 'fa-caret-down'"
                style="min-width: 2em"
            />
            {{ params.value }}
        </span>
    </div>
</template>

<script setup lang="ts">
import { IconComp } from '@/components';
import type { IRowNode } from 'ag-grid-community';
import { ref } from 'vue';

const props = defineProps<{
    params: any;
}>();

const isCollpased = ref(props.params.node.expanded);

const toggleGroup = () => {
    let rowNode = props.params.node as IRowNode;
    props.params.api!.getRowNode(rowNode.id)!.setExpanded(!rowNode.expanded);
};
</script>
